// Series order seed — the sequence competitions are shown in inside a sport.
//
// WHY THIS FILE EXISTS. The upstream feed returns the SAME competitions in a
// DIFFERENT order every few minutes. Measured on the live tree (Football, 102
// matches throughout, every whitelabel host returning the identical shuffle at
// the same instant):
//   22:34  Europa · TESTING · CHILE Ascenso · JAMAICA · PANAMA · EFL Cup
//   22:42  Europa · LaLiga · CHILE Primera · AFC CL · ARG Regional · EFL Cup
//   22:51  Europa · TESTING · CHILE Ascenso · JAMAICA · GERMANY 3. Liga · SWEDEN
// So the feed carries no ordering to honour, and no rule recreates one: 3698
// candidate sorts were tested against a count-matched reference capture (43
// fields — cid, gmid, mid, oid, gscode, m, rc, stime, in-play/tv/bm counts —
// each as min/max/sum, ascending and descending, singly and in every pair) and
// not one reproduced it. The reference is not sorting either: it HOLDS an order
// and slots new competitions in, which is why its captures 28 minutes apart
// differ by two rows out of 28.
//
// This file is that held order, taken from the reference sidebar, keyed by
// etid. Sports 4 (Cricket), 1 (Football) and 2 (Tennis) were re-read from the
// 2026-09-23 capture (tenexch.com-admin-market-analysis-1790174200929) after
// the user reported those three drifting; every other sport is still the
// 2026-09-15 reading. It is the STARTING order only — see
// holdSeriesOrder(): names still here keep their place, names the feed dropped
// fall out, and anything new is inserted next to the sibling it arrived behind.
// So the file degrades safely as the fixture list turns over; it is never a
// filter and never hides a competition that is missing from it.
//
// Regenerating: capture the reference sidebar DOM and read the series order per
// sport. Keep both copies (frontend/ and admin/) in step.

export const SERIES_ORDER_SEED = {
  "40": [
    "Assembly Election 2026"
  ],
  "4": [
    "Virtual Cricket League",
    "One Day Internationals",
    "Dim Cricket League (1 over)",
    "Australia One-Day Cup 2026",
    "Womens One Day Internationals",
    "County Championship Division One TEST"
  ],
  "1": [
    "URUGUAY Copa Uruguay",
    "BHUTAN Premier League",
    "ITALY Eccellenza",
    "COLOMBIA Primera A",
    "TESTING",
    "AFRICA COSAFA Championship U20",
    "WORLD WORLD CUP WOMEN U20 - SEMI-FINALS",
    "EUROPE UEFA Europa Cup Women - Qualification",
    "EUROPE UEFA NATIONS LEAGUE",
    "PARAGUAY Copa Paraguay",
    "ENGLAND Womens League Cup",
    "ARGENTINA Youth League",
    "ASIA Arabian Gulf Cup",
    "EL SALVADOR Primera Division",
    "EUROPE UEFA Champions League Women",
    "THAILAND  Cup",
    "CHILE Copa Chile",
    "NORTH and CENTRAL AMERICA CONCACAF Nations League",
    "SOUTH AMERICA SOUTH AMERICAN GAMES WOMEN U20-FINAL",
    "UNITED ARAB EMIRATES Presidents Cup",
    "ZANZIBAR Premier league",
    "MALAYSIA President Cup",
    "SLOVAKIA Slovak Cup",
    "SOUTH AMERICA SOUTH AMERICAN GAMES WOMEN U20",
    "USA MLS",
    "PERU Liga 1",
    "GUATEMALA Liga Nacional",
    "ALGERIA Ligue 1",
    "SCOTLAND Challenge Cup",
    "CANADA Canadian Premier League",
    "THAILAND U21 League",
    "CZECH REPUBLIC MOL Cup",
    "NORWAY NM Cup"
  ],
  "2": [
    "CHALLENGER MEN - SINGLES SAN DIEGO 2 (USA)",
    "CHALLENGER WOMEN - DOUBLES ANKARA (TURKEY)",
    "CHALLENGER MEN -SINGLES BUENOS AIRES 3 (ARGENTINA)",
    "CHALLENGER MEN- DOUBLES BUENOS AIRES 3 (ARGENTINA)",
    "CHALLENGER MEN - DOUBLES SAN DIEGO 2 (USA)",
    "CHALLENGER WOMEN - SINGLES ANKARA (TURKEY)",
    "CHALLENGER MEN - DOUBLES GENOVA 2 (ITALY)",
    "CHALLENGER WOMEN - SINGLES PORTO (PORTUGAL)",
    "CHALLENGER MEN - SINGLES GENOVA 2 (ITALY)",
    "CHALLENGER MEN - DOUBLES PLOVDIV 4 (BULGARIA)",
    "CHALLENGER WOMEN - DOUBLES  PORTO (PORTUGAL)",
    "CHALLENGER MEN - SINGLES ST. TROPEZ (FRANCE)",
    "CHALLENGER WOMEN - SINGLES TOLENTINO (ITALY)",
    "Testing",
    "CHALLENGER MEN - SINGLES PLOVDIV 4 (BULGARIA)"
  ],
  "10": [
    "IE",
    "US",
    "GB",
    "FR"
  ],
  "65": [
    "GB",
    "AU"
  ],
  "8": [
    "CZECH Liga Pro",
    "MEN Setka Cup (World)",
    "TT Elite Series",
    "Testing Game"
  ],
  "15": [
    "URUGUAY  Liga Women",
    "EUROPE CHAMPIONS LEAGUE-QUALIFICATION 2",
    "WORLD CLUB FRIENDLIES",
    "BRAZIL Paulista FPB U20",
    "EL SALVADOR Liga Mayor Women",
    "CHILE LNB - CLAUSURA",
    "FRANCE  FRENCH CUP",
    "ASIA ASIAN GAMES - QUARTER-FINALS",
    "BRAZIL LDB U22",
    "FINLAND Suomen Cup",
    "URUGUAY Liga de Ascenso",
    "DOMINICAN Rep Superior de Santiago",
    "PARAGUAY LNB - CLAUSURA",
    "EL SALVADOR Liga Mayor",
    "HONG KONG A1",
    "BRAZIL Championship U23 Women",
    "MEXICO LNBP",
    "PUERTO RICO Superior Nacional Women",
    "PARAGUAY  LNB - CLAUSURA",
    "SOUTH KOREA University League Women",
    "Testing"
  ],
  "18": [
    "EUROPE EUROPEAN CHAMPIONSHIPS",
    "SOUTH AMERICA SOUTH AMERICAN CHAMPIONSHIP",
    "WORLD PAN-AMERICAN CUP WOMEN",
    "ARGENTINA Super Segunda Women",
    "VIETNAM Championship U23 Women",
    "VIETNAM Championship U23",
    "CZECH REPUBLIC  Regional League  Women",
    "BRAZIL  Paulista U21",
    "BRAZIL Paulista Women",
    "UNITED STATES NCAA Championship Women",
    "NORTH and CENTRAL AMERICA  NORCECA CHAMPIONSHIP"
  ],
  "17": [
    "Madhya Pradesh League 2026",
    "Kerala Cricket League 2026"
  ],
  "52": [
    "AZERBAIJAN GRAND PRIX - 2026"
  ],
  "54": [
    "WWE Virtual"
  ],
  "58": [
    "USA NFL"
  ],
  "69": [
    "WWE Virtual"
  ]
}
